import {initPAC} from "./pac"
import getPosition from "@rmlibrary/dom-util";

initPAC();
